import { useEffect, useState } from "react";
import { handleSettingData, handleLogoUpload, handleRemoveLogoAPI } from "../../services/userProfile";
import { showToastMessage } from "../../helpers/toastr";
import { MdDelete } from "react-icons/md";

const LogoSetting = ({ selectGlobalOrg, userData }) => {
    console.log(selectGlobalOrg, ' this is the select ordg')
    console.log(userData, ' thisis the userdata')
    const [data, setData] = useState(null);
    const [error, setErrors] = useState({});
    const [logoPreview, setLogoPreview] = useState(null);

    const storedOrgId = localStorage.getItem("organisation");

    const [formData, setFormData] = useState({
        orgId: "",
        siteLogo: null,
    });

    useEffect(() => {
        fetchData();
    }, [selectGlobalOrg]);

    const BASE_URL = process.env.REACT_APP_BASE_URL;
    const CLEAN_BASE_URL = BASE_URL.replace(/\/api\/?$/, ""); // Removes /api/ at the end

    useEffect(() => {
        if (data) {
            console.log(data, ' this is the data ');

            setFormData((prev) => ({
                ...prev,
                orgId: data.org_id,
                siteLogo: prev.siteLogo instanceof File
                    ? prev.siteLogo
                    : data.organisation?.logo
                        ? `${BASE_URL}/${data.organisation.logo}`
                        : null,
            }));

            setLogoPreview(
                data.organisation?.logo
                    ? data.organisation.logo.startsWith("http")
                        ? data.organisation.logo.replace("http://", "https://") // Ensure HTTPS
                        : `${CLEAN_BASE_URL}/storage/${data.organisation.logo}`
                    : null
            );
        }
    }, [data]);




    useEffect(() => {
        if (userData?.get_orgnaisation?.length > 0) {
            let storedOrgId = localStorage.getItem("organisation");

            if (!storedOrgId) {
                // If no organisation in localStorage, set the first organisation as default
                const firstOrg = userData.get_orgnaisation[0];
                localStorage.setItem("organisation", firstOrg.organisation_id);
                storedOrgId = firstOrg.organisation_id; // Update storedOrgId for further use
            }

            const matchedOrg = userData.get_orgnaisation.find(
                (org) => org.organisation_id.toString() === storedOrgId
            );

            if (matchedOrg) {
                setFormData((prev) => ({
                    ...prev,
                    orgId: matchedOrg.organisation_id,
                    siteLogo: matchedOrg.organisation.logo || null, // Fetch logo from organisation table
                }));
                setLogoPreview(matchedOrg.organisation.logo);
            }
        }
    }, [userData]);


    const validateForm = () => {
        let isValid = true;
        const newErrors = {};

        if (!(formData.siteLogo instanceof File)) {
            newErrors.siteLogo = "Please upload a valid image file.";
            isValid = false;
        }

        setErrors(newErrors);
        return isValid;
    };

    const handleImageChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            if (!["image/jpeg", "image/png", "image/webp", "image/avif"].includes(file.type)) {
                setErrors({
                    siteLogo: "Invalid file type. Only JPEG, PNG, WebP, and AVIF are allowed.",
                });
                return;
            }
            setErrors({});
            setFormData((prevFormData) => ({ ...prevFormData, siteLogo: file }));
            setLogoPreview(URL.createObjectURL(file));
        }
    };

    const fetchData = async () => {
        try {
            const result = await handleSettingData(Number(storedOrgId));
            if (result?.data) {
                setData(result.data.data);
            }
        } catch (error) {
            showToastMessage("error", error.response?.data.message);
        }
    };
    const handleSave = async () => {
        if (validateForm()) {
            try {
                const formDataToSend = new FormData();

                console.log("Uploading file:", formData.siteLogo); // Debugging

                if (!(formData.siteLogo instanceof File)) {
                    showToastMessage("error", "Invalid file selected. Please choose a valid image.");
                    return;
                }

                formDataToSend.append("siteLogo", formData.siteLogo);
                formDataToSend.append("orgId", storedOrgId);

                console.log("FormData Entries:", [...formDataToSend.entries()]); // Debugging

                const orgId = parseInt(storedOrgId, 10);
                const result = await handleLogoUpload(formDataToSend, orgId);

                if (result.data) {
                    showToastMessage("success", "Logo updated successfully");

                    // Reload the window after a short delay to ensure the toast message is seen
                    setTimeout(() => {
                        window.location.reload();
                    }, 1000);
                }
            } catch (error) {
                showToastMessage("error", error.response?.data.message || "An error occurred.");
            }
        }
    };

    const handleRemoveLogo = async () => {
        try {
            const orgId = parseInt(storedOrgId, 10);
            const result = await handleRemoveLogoAPI(orgId);

            if (result.data) {
                showToastMessage("success", "Logo removed successfully");

                setFormData((prev) => ({
                    ...prev,
                    siteLogo: null,
                }));
                setLogoPreview(null);
                setTimeout(() => {
                    window.location.reload();
                }, 1000);
            }
        } catch (error) {
            showToastMessage("error", error.response?.data.message || "Failed to remove logo.");
        }
    };





    return (
        <>
            <form className="mx-auto form mt-4">
                <div className="card p-4">
                    <div className="row">
                        <div className="col-md-6 col-12">
                            <div className="form-group">
                                <label htmlFor="siteLogo" className="form-label">Upload Site Logo:</label>
                                <input
                                    type="file"
                                    className="form-control"
                                    id="siteLogo"
                                    name="siteLogo"
                                    accept="image/jpeg, image/png, image/webp, image/avif"
                                    onChange={handleImageChange}
                                />
                                {error.siteLogo && <div className="text-danger">{error.siteLogo}</div>}
                            </div>
                            {logoPreview && (
                                <div className="mt-3 position-relative d-inline-block">
                                    <img
                                        src={logoPreview}
                                        alt="Logo Preview"
                                        style={{
                                            maxWidth: "150px",
                                            maxHeight: "100px",
                                            borderRadius: "8px",
                                            position: "relative",
                                        }}
                                    />
                                    {/* Delete Icon */}
                                    <MdDelete
                                        onClick={handleRemoveLogo}
                                        className="position-absolute"
                                        style={{
                                            top: "-5px",
                                            right: "-10px",
                                            color: "red",
                                            fontSize: "20px",
                                            cursor: "pointer",
                                            background: "white",
                                            borderRadius: "50%",
                                            padding: "2px",
                                            boxShadow: "0px 0px 5px rgba(0,0,0,0.2)",
                                        }}
                                    />
                                </div>
                            )}
                        </div>

                        <div className="col-md-12 col-12 text-end">
                            <button type="button"
                                className="button button-primary button-icon-left"
                                onClick={handleSave}
                            >
                                Save Logo
                            </button>
                        </div>
                    </div>
                </div>
            </form>
        </>
    );
};

export default LogoSetting;
